import { IToolTipSpecifications } from '@lifk/types'
import type { EventBusKey } from '@vueuse/core'

type TTooltipEventType =
  | 'show'
  | 'hide'
  | 'toggle'
  | 'pointerLeaveTarget'
  | 'afterShow'
  | 'afterHide'
export interface ToolTipEvent {
  type: TTooltipEventType
  specs?: IToolTipSpecifications
}

export const ToolTipEventKey: EventBusKey<ToolTipEvent> = Symbol()
